import { Flex } from "antd";
import { FC } from "react";

import { formatKPIValue, KPI_ICONS } from "@/domains/kpi";
import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";

import { StyledAPPlanItemContainer, StyledAPPlanValue } from "../../../Styled";
import { KpiKey, PlanValueResult } from "../InfoTabPlan.model";
import { StyledRowValues } from "../Styled";

interface IPlanFinGroupRow {
    finGroup: string;
    b: PlanValueResult;
    l: PlanValueResult;
    m: PlanValueResult;
}

const KPI_KEYS: KpiKey[] = ["b", "l", "m"];

export const PlanFinGroupRow: FC<IPlanFinGroupRow> = ({
    finGroup,
    b,
    l,
    m,
}) => (
    <StyledAPPlanItemContainer>
        <SecondaryText fontSize={14} fontWeight="400">
            {finGroup}
        </SecondaryText>

        <StyledRowValues>
            {KPI_KEYS.map((key) => {
                const Icon = KPI_ICONS[key];
                const item = { b, l, m }[key];

                return (
                    <Flex key={key} align="center" justify="center">
                        <StyledAPPlanValue
                            fontSize={12}
                            fontWeight="400"
                            $isCompleted={item.isCompleted}
                        >
                            {item.value}
                        </StyledAPPlanValue>

                        {Icon && (
                            <PrimaryText fontSize={20}>
                                <Icon />
                            </PrimaryText>
                        )}
                    </Flex>
                );
            })}
        </StyledRowValues>
    </StyledAPPlanItemContainer>
);

export const renderValue = (
    motivationType: KpiKey,
    planValue: number,
    factValue?: number,
): PlanValueResult =>
    factValue
        ? {
              value: `${formatKPIValue({
                  value: factValue,
                  motivationType,
              })} / ${formatKPIValue({
                  value: planValue,
                  motivationType,
              })}`,
              isCompleted: factValue >= planValue,
          }
        : {
              value: formatKPIValue({
                  value: planValue,
                  motivationType,
              }),
              isCompleted: false,
          };
